import { selectBusiness } from '@pages/profile/store/selectors';
import { useSelector } from 'react-redux';
import { getExchangeResult } from '../utils/convertion';
import useBoolean from './useBoolean';

interface UseGetExchangeProps {
  rateUuid: string;
}

const useGetExchange = ({ rateUuid }: UseGetExchangeProps) => {
  const company = useSelector(selectBusiness);
  const [loading, { setFalse: hideLoading, setTrue: showLoading }] =
    useBoolean(false);

  const handleGetExchange = ({
    amountToConvert,
    reverse,
    onChangeResult,
  }: {
    amountToConvert: string;
    reverse: boolean;
    onChangeResult: (amount: number) => void;
  }) => {
    showLoading();
    getExchangeResult({
      amount: amountToConvert,
      reverse,
      rateUuid,
      enterpriseId: company?.enterpriseId || '0',
      onChangeResult({ amount }) {
        onChangeResult(amount);
        hideLoading();
      },
      setCancelFunction() {},
    });
  };

  return {
    handleGetExchange,
    loading,
  };
};

export default useGetExchange;
